<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn class="elevation-0 rounded-tag-small normal-btn-text"
             :color="iconColor"
             v-on="on"
             @click.stop.prevent=""
      >
        Filtrar dashboard
        <v-icon small>mdi-filter-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Solicitantes responsáveis"
              :roles="['ROLE_REQUISICAO']"
              class="rounded-tag-small"
              v-model="localSolicitante"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Compradores responsáveis"
              :roles="['ROLE_COMPRADOR']"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                              class="rounded-tag-small"
                                              show-details
                                              dense
                                              base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              class="rounded-tag-small"
              dense
              search-in-requisicao
              search-in-compra
              search-in-cotacao
              search-by-codigo-interno
              v-model="localFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              label="Tipo de produto"
              :items="tiposProduto"
              class="rounded-tag-small"
              v-model="localTipoProduto"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { TipoProduto } from 'px-business-components';

export default {
  props: {},
  data: () => ({
    tiposProduto: TipoProduto.values,
    menuOpened: false,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localGrupo: [],
    localFornecedor: [],
    localSolicitante: [],
    localTipoProduto: null,
  }),
  computed: {
    ...mapGetters('metabaseDashboard', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['metabaseDashboard/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('metabaseDashboard/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['metabaseDashboard/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('metabaseDashboard/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['metabaseDashboard/produto'];
      },
      set(produto) {
        this.$store.dispatch('metabaseDashboard/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['metabaseDashboard/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('metabaseDashboard/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['metabaseDashboard/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('metabaseDashboard/responsavel', responsavel);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['metabaseDashboard/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('metabaseDashboard/grupo', grupo);
      },
    },
    fornecedor: {
      get() {
        return this.$store.getters['metabaseDashboard/fornecedor'];
      },
      set(fornecedor) {
        this.$store.dispatch('metabaseDashboard/fornecedor', fornecedor);
      },
    },
    solicitante: {
      get() {
        return this.$store.getters['metabaseDashboard/solicitante'];
      },
      set(solicitante) {
        this.$store.dispatch('metabaseDashboard/solicitante', solicitante);
      },
    },
    tipoProduto: {
      get() {
        return this.$store.getters['metabaseDashboard/tipoProduto'];
      },
      set(tipoProduto) {
        this.$store.dispatch('metabaseDashboard/tipoProduto', tipoProduto);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.grupo = this.localGrupo;
      this.fornecedor = this.localFornecedor;
      this.solicitante = this.localSolicitante;
      this.tipoProduto = this.localTipoProduto;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localGrupo = null;
      this.localFornecedor = null;
      this.localSolicitante = null;
      this.localTipoProduto = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localGrupo = this.grupo || [];
    this.localFornecedor = this.fornecedor || [];
    this.localSolicitante = this.solicitante || [];
    this.localTipoProduto = this.tipoProduto || null;
  },
};
</script>
